// The client form's save — what to write, and only that (Add / Edit Client: src/components/AddClientModal.js).
//
// ⛔ SAVE ONLY WHAT CHANGED. A field is written only when its value differs from the row as LOADED FROM THE DATABASE
// when the form opened, so an untouched field is never overwritten — even one the form displays differently (a stored
// Client Type that isn't one of the options), and even if the page's own copy of the client was stale. A field the
// user deliberately empties IS written, as NULL: clearing works. This replaces Admin Console's old "never write a
// blank" guard (c71ccda), which protected untouched fields by making every field impossible to clear.
// Same rule as the parcel save (src/utils/parcelSave.js).

// Every client field the form edits, in form order. The primary contact is NOT here: it is the client screen's contact
// record (utils/clientPrimaryContact), no longer the clients.primary_contact_* columns. status is NOT here: the client
// page's Retire/Unretire toggle is its only writer (it confirms first). id is never edited (derived from the name).
export const CLIENT_FIELDS = [
  'name', 'short_name', 'client_type', 'client_since_year',
  'billing_contact', 'contract_start_date',
  'address_line1', 'address_line2', 'city', 'state', 'zip', 'notes',
];

const norm = (v) => (v == null ? '' : String(v).trim());

// A stored row → the form's state (null → '', so inputs stay controlled).
export function clientToForm(row) {
  const f = {};
  for (const k of CLIENT_FIELDS) f[k] = norm(row && row[k]);
  return f;
}

// '' → null (no year); otherwise a 4-digit year from 1900 to the current year, or an error.
export function parseSinceYear(v, now = new Date()) {
  const s = norm(v);
  if (!s) return { value: null };
  if (!/^\d{4}$/.test(s)) return { error: 'Client since must be a 4-digit year, or blank.' };
  const y = Number(s);
  if (y < 1900 || y > now.getFullYear()) return { error: `Client since must be between 1900 and ${now.getFullYear()}.` };
  return { value: y };
}

// Editing only (creating a client keeps its own insert in AddClientModal, shared in shape with Bulk Import).
// original: the row as loaded when the form opened. form: the form state. → { patch } (possibly empty) or { error }.
export function clientPatch(original, form) {
  if (!norm(form.name)) return { error: 'Client Name is required.' };
  const since = parseSinceYear(form.client_since_year);
  if (since.error) return { error: since.error };
  const patch = {};
  for (const k of CLIENT_FIELDS) {
    const next = norm(form[k]);
    if (next === norm(original[k])) continue;                 // unchanged → never written
    patch[k] = k === 'client_since_year' ? since.value : (next === '' ? null : next);
  }
  return { patch };
}
